import type React from 'react'
import styled from 'styled-components'

import Checkbox from '@/components/Checkbox'
import H6 from '@/components/H6'

export interface Props {
  isRequired: boolean
  sanctionsVerified: boolean | null
  setSanctionsVerified: (sanctionsVerified: boolean) => void
}

const StyledCheckboxContainer = styled.div`
  margin-top: 10px;
`

const SanctionsVerification = ({
  isRequired,
  sanctionsVerified,
  setSanctionsVerified,
}: Props) => (
  <div>
    <H6>Sanctions verification {isRequired ? '' : '(Not applicable)'}</H6>
    <StyledCheckboxContainer>
      <Checkbox
        testId="sanctions-verification-checkbox"
        label="I confirm that I have verified the applicant's sanctions status on Credas"
        checked={sanctionsVerified ?? false}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setSanctionsVerified(e.target.checked)
        }}
        disabled={!isRequired}
      />
    </StyledCheckboxContainer>
  </div>
)

export default SanctionsVerification
